export const assetHistoryCategories = [
  {
    label: 'Usage',
    value: 'usage',
  },
  {
    label: 'Service',
    value: 'service',
  },
  {
    label: 'Refill',
    value: 'refill',
  },
  {
    label: 'Lock Out',
    value: 'lock_out',
  },
  {
    label: 'Other',
    value: 'other',
  }
]